import Store from '@/store/computed/storeHelpers'
export default {
  computed: {
    defaultHeaders: Store.getSet({
      store: 'shared',
      prop: 'rateDefaultHeaders'
    })
  },
  methods: {
    calculateTotal(array, prop) {
      return this.$worker.run(
        (array, prop) => {
          var total = 0
          for (var row of array) {
            if (!!row[prop]) {
              var number = Number(row[prop])
              total += number
            }
          }
          return total
        },
        [array, prop]
      )
    }
  },
  asyncComputed: {
    async totalCost() {
      return await this.calculateTotal(this.filteredRates, 'costTotal')
    },
    async totalSell() {
      return await this.calculateTotal(this.filteredRates, 'sellTotal')
    },
    async totalHours() {
      return await this.calculateTotal(this.filteredRates, 'hours')
    },
    async totalSiteWeight() {
      return await this.calculateTotal(this.filteredRates, 'siteWeight')
    },
    async totalTipWeight() {
      return await this.calculateTotal(this.filteredRates, 'tipWeight')
    },
    async totalScaleWeight() {
      return await this.calculateTotal(this.filteredRates, 'scaleWeight')
    }
  },
  data() {
    return {
      allPossibleHeaders: [
        {
          text: 'Active',
          align: 'left',
          value: 'active',
          colData: 'active',
          type: 'bool',
          //type: "text",
          show: false
        },
        {
          text: 'Rate ID',
          align: 'left',
          value: 'id',
          colData: 'id',
          type: 'text',
          show: false
        },
        {
          text: 'Created',
          align: 'left',
          value: 'createdAt',
          colData: 'createdAt',
          type: 'date',
          show: false
        },
        {
          text: 'Updated',
          align: 'left',
          value: 'updatedAt',
          colData: 'updatedAt',
          type: 'date',
          show: false
        },
        {
          text: 'Project',
          align: 'left',
          value: 'project.name',
          colData: 'project.name',
          type: 'text',
          show: false
        },
        {
          text: 'Site',
          align: 'left',
          value: 'site.name',
          colData: 'site.name',
          type: 'text',
          show: false
        },
        {
          text: 'Tip',
          align: 'left',
          value: 'tip.name',
          colData: 'tip.name',
          type: 'text',
          show: false
        },
        {
          text: 'Spoil',
          align: 'left',
          value: 'spoil.name',
          colData: 'spoil.name',
          type: 'text',
          show: false
        },
        {
          text: 'Vehicle Type',
          align: 'left',
          value: 'vehicleType.name',
          colData: 'vehicleType.name',
          type: 'vehicleTypes',
          show: false
        },
        {
          text: 'Cost',
          align: 'right',
          value: 'costPrice',
          colData: 'costPrice',
          type: 'price',
          unit: 'costUnit',
          show: false
        },
        {
          text: 'Cost Alt',
          align: 'right',
          value: 'costPriceAlt',
          colData: 'costPriceAlt',
          type: 'price',
          unit: 'costUnitAlt',
          show: false
        },
        {
          text: 'Sell',
          align: 'right',
          value: 'sellPrice',
          colData: 'sellPrice',
          type: 'price',
          unit: 'sellUnit',
          show: false
        },
        {
          text: 'Sell Alt',
          align: 'right',
          value: 'sellPriceAlt',
          colData: 'sellPriceAlt',
          type: 'price',
          unit: 'sellUnitAlt',
          show: false
        },
        {
          text: 'Sunday Cost',
          align: 'right',
          value: 'costPriceSunday',
          colData: 'costPriceSunday',
          type: 'price',
          unit: 'sellUnitSunday',
          show: false
        },
        {
          text: 'Sunday Cost Alt',
          align: 'right',
          value: 'costPriceAltSunday',
          colData: 'costPriceAltSunday',
          type: 'price',
          unit: 'costUnitAlt',
          show: false
        },
        {
          text: 'Sunday Sell',
          align: 'right',
          value: 'sellPriceSunday',
          colData: 'sellPriceSunday',
          type: 'price',
          unit: 'sellUnitSunday',
          show: false
        },
        {
          text: 'Sunday Sell Alt',
          align: 'right',
          value: 'sellPriceAltSunday',
          colData: 'sellPriceAltSunday',
          type: 'price',
          unit: 'sellUnitAlt',
          show: false
        },
        {
          text: 'Night Cost',
          align: 'right',
          value: 'costPriceNight',
          colData: 'costPriceNight',
          type: 'price',
          unit: 'costUnitNight',
          show: false
        },
        {
          text: 'Night Sell',
          align: 'right',
          value: 'sellPriceNight',
          colData: 'sellPriceNight',
          type: 'price',
          unit: 'sellUnitNight',
          show: false
        },
        {
          text: 'Admin Fee',
          align: 'right',
          value: 'adminFeeRequired',
          colData: 'adminFeeRequired',
          type: 'bool',
          decimals: 0,
          show: false
        },
        {
          text: 'Use Tonnage',
          align: 'right',
          value: 'useTonnage',
          colData: 'useTonnage',
          type: 'text',
          show: false
        },
        {
          text: 'Notes',
          align: 'left',
          value: 'notes',
          colData: 'notes',
          type: 'text',
          show: false
        },
        {
          text: 'Created By',
          align: 'left',
          value: 'user.name',
          colData: 'user.name',
          type: 'text',
          show: false
        }
      ]
    }
  }
}
